import { render, staticRenderFns } from "./ParagraphTitle.vue?vue&type=template&id=32588e49&name=paragraph-title&"
import script from "./ParagraphTitle.vue?vue&type=script&lang=js&"
export * from "./ParagraphTitle.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports